var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExtenalPath)?_c('router-link',{class:_vm.extraClass,attrs:{"to":_vm.linkStr}},[_vm._t("default")],2):_c('a',{class:("" + _vm.extraClass),attrs:{"href":_vm.linkStr}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }